import i18next from 'i18next';
import * as Yup from 'yup';
import { timeStringToSeconds } from '../timeStringToSeconds';

const useSaveMediaFormValidation = () => {
  return Yup.object({
    title: Yup.string().required(i18next.t('pages:library.saveMedia.fields.title.required')),
    // Date Picker returns an error message regarding invalid date format, need to override in component field
    airDate: Yup.date().required(),
    airTime: Yup.string().required(i18next.t('pages:library.saveMedia.fields.airTime.required')),
    adminApproveAiOverage: Yup.boolean().when(['aiEnhance', 'aiVideoLimitExceeded'], {
      is: (aiEnhance: boolean, aiVideoLimitExceeded: boolean) => aiEnhance && aiVideoLimitExceeded,
      then: (schema) => schema.oneOf([true]),
      otherwise: (schema) => schema.notRequired(),
    }),
    startTime: Yup.string()
      .required(i18next.t('pages:library.trimLibraryVideo.errors.startTimeRequired'))
      .test(
        'start-not-equal-end',
        i18next.t('pages:library.trimLibraryVideo.errors.startTimeAndEndTimeEqual'),
        function (value: string | undefined) {
          const { endTime } = this.parent;
          if (!value || !endTime) return true;
          return timeStringToSeconds(value) !== timeStringToSeconds(endTime);
        }
      )
      .test(
        'start-before-end',
        i18next.t('pages:library.trimLibraryVideo.errors.startTimeAfterEndTime'),
        function (value: string | undefined) {
          const { endTime } = this.parent;
          if (!value || !endTime) return true;
          return timeStringToSeconds(value) < timeStringToSeconds(endTime);
        }
      ),
    endTime: Yup.string()
      .required(i18next.t('pages:library.trimLibraryVideo.errors.endTimeRequired'))
      .test(
        'end-not-equal-start',
        i18next.t('pages:library.trimLibraryVideo.errors.startTimeAndEndTimeEqual'),
        function (value: string | undefined) {
          const { startTime } = this.parent;
          if (!value || !startTime) return true;
          return timeStringToSeconds(value) !== timeStringToSeconds(startTime);
        }
      )
      .test(
        'end-after-start',
        i18next.t('pages:library.trimLibraryVideo.errors.startTimeAfterEndTime'),
        function (value: string | undefined) {
          const { startTime } = this.parent;
          if (!value || !startTime) return true;
          return timeStringToSeconds(value) > timeStringToSeconds(startTime);
        }
      ),
  });
};

export default useSaveMediaFormValidation;
